import { isIsoDate } from '../../validation/is-iso-date.function';
import { isIsoDateTime } from '../../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../../validation/is-iso-date-time-tz.function';
import { getTimeOffset } from '../../get/get-time-offset.function';
import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { getLastDayOfMonth } from '../../helper/last-day-of-month.function';
import { constructDate } from '../../helper/construct-date.function';
import { getLastMonthOfQuarter } from '../../helper/last-month-of-quarter';

/**
 * Returns the end of the quarter for the given ISO input.
 * - Date-only (YYYY-MM-DD) -> 'YYYY-MM-DD' of quarter end
 * - Date-time without tz -> 'YYYY-MM-DDT23:59:59.999'
 * - Date-time with tz -> 'YYYY-MM-DDT23:59:59.999Z|±HH:MM'
 */
export function endOfQuarter<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (deconstructed._type !== 'date' && deconstructed._type !== 'dateTime' && deconstructed._type !== 'dateTimeTz') {
    throw new Error('endOfQuarter: invalid ISO date/time string');
  }
  deconstructed.month = getLastMonthOfQuarter(deconstructed.month);
  deconstructed.day = getLastDayOfMonth(deconstructed.year, deconstructed.month);
  if (deconstructed._type !== 'date') {
    deconstructed.hours = 23;
    deconstructed.minutes = 59;
    deconstructed.seconds = 59;
    deconstructed.milliseconds = 999;
  }
  return constructDate(deconstructed) as unknown as T;
}

